import { motion } from 'motion/react';
import { ClientsShowcaseCarousel } from '../components/ClientsJourney/ClientsShowcaseCarousel';
import { CallToAction } from '../components/ClientsJourney/CallToAction';
import { Footer } from '../components/Footer';
import { clientCollaborations } from '../data/clientsJourneyData';

interface ClientsJourneyPageProps {
  onContact?: () => void;
  onBack?: () => void;
}

export default function ClientsJourneyPage({ onContact, onBack }: ClientsJourneyPageProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="bg-background min-h-screen text-foreground font-sans overflow-x-hidden"
    >
      {/* Clients Showcase Carousel */}
      <ClientsShowcaseCarousel clients={clientCollaborations} onBack={onBack} />

      {/* Call to Action Section */}
      <CallToAction onContact={onContact} />

      {/* Footer */}
      <Footer
        onRequestDemo={onContact || (() => console.log("Request Demo"))}
        onNavigateToSpecialized={() => window.location.href = "/#specialized-offerings"}
      />
    </motion.div>
  );
}
